import * as React from 'react';
import Space from 'antd/lib/space';
import Tooltip, { TooltipPlacement } from 'antd/lib/tooltip';
import groupBy from 'lodash/groupBy';
import { Integration } from '../../types';
import { iconAndAltForIntegrationType } from '../../helpers/integrationHelpers';
import { getIntegrationLabel } from '../../helpers/integrationSelectHelpers';
import IntegrationIcon from './IntegrationIcon';

interface IntegrationIconsProps {
    integrations: Integration[];
    size?: number;
    onClick?: () => void;
    tooltipPlacement?: TooltipPlacement;
}

export const IntegrationIcons: React.FC<IntegrationIconsProps> = ({
    integrations,
    size = 16,
    onClick,
    tooltipPlacement,
}) => {
    // Grouped by icon, not type: e.g. Datadog stability and Datadog observability share one logo.
    const groups = Object.values(
        groupBy(integrations, (integration) => iconAndAltForIntegrationType(integration.id)[0] ?? integration.id),
    );
    const style: React.CSSProperties = { cursor: onClick ? 'pointer' : undefined, display: 'inline-flex' };

    return (
        <Space size={12} align="center">
            {groups.map((group) => (
                <Tooltip
                    key={group[0].installationId}
                    title={renderLabels(group)}
                    placement={tooltipPlacement}
                    overlayStyle={{ maxWidth: 400 }}
                >
                    <span style={style} onClick={onClick}>
                        <IntegrationIcon integrationId={group[0].id} size={size} />
                    </span>
                </Tooltip>
            ))}
        </Space>
    );
};

const renderLabels = (integrations: Integration[]) =>
    integrations.map((integration) => <div key={integration.installationId}>{getIntegrationLabel(integration)}</div>);
